import { BaseEntity } from ".";
import { StaticStorageClient } from "../service/staticstorageclient";
import { getCachedStationEntity } from "./StationEntityCache";

const azureStorageClient = new StaticStorageClient();

export class SolarSystemEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Solar System";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    //const id = this._id;
    const props = this.props;

    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      // - Data Type
      entity.properties["data_type"] = {
        type: Excel.CellValueType.string,
        basicValue: "Solar System",
      };
      entity.text = "Solar System";
      // - Name
      if (props.name) {
        entity.text = props.name.en.toString();
        entity.properties["name"] = props.name.en.toString();
      }
      // - Only Region Name so we don't do an infinite loop
      if (props.regionID) {
        const region = await azureStorageClient.get_region_by_id(props.regionID);
        if (region !== null) {
          if (region.name)
            entity.properties["region_name"] = { type: Excel.CellValueType.string, basicValue: region.name.en };
        }
        entity.properties["region_id"] = entity.properties["regionID"];
        delete entity.properties["regionID"];
      }
      if (props.constellationID) {
        const constellation = await azureStorageClient.get_constellation_by_id(props.constellationID);
        if (constellation !== null) {
          if (constellation.name.en)
            entity.properties["constellation_name"] = {
              type: Excel.CellValueType.string,
              basicValue: constellation.name.en,
            };
        }
        entity.properties["constellation_id"] = entity.properties["constellationID"];
        delete entity.properties["constellationID"];
      }
      const stationList = await azureStorageClient.get_stations_in_system(this._id);
      if (stationList !== null) {
        let station_array: Excel.CellValue[][] = [];
        for (const y of stationList) {
          const station = await getCachedStationEntity(y.stationID);
          if (station !== null) station_array.push([await station.toJson(true)]);
        }
        if (station_array.length) {
          entity.properties["stations"] = {
            type: Excel.CellValueType.array,
            elements: station_array,
          };
        }
      }
    }
    // Layouts
    entity.layouts = {
      card: {
        //title: { property: "name" },
      },
      compact: {
        icon: "Atom",
      },
    };

    return entity;
  }
}
